import dayjs from "dayjs";
const currentYear = dayjs().year(); // dynamically get current year
// Function to format date as dd/mm/yyyy
export function formatDate(dateString) { // the dateString is like ="2025-01-31"
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
}

// Utility function to convert 'DD-MM-YYYY' to 'YYYY-MM-DD'
export const convertToISO = (dateStr) => {
    if (!dateStr || typeof dateStr !== 'string' || !dateStr.includes('-')) return null;

    const [day, month, year] = dateStr.split('-');
    if (!day || !month || !year) return null;

    return `${year}-${month}-${day}`;
};



// Generate month list (without "All")
export const monthsList = [
  { label: 'January', value: '01' },
  { label: 'February', value: '02' },
  { label: 'March', value: '03' },
  { label: 'April', value: '04' },
  { label: 'May', value: '05' },
  { label: 'June', value: '06' },
  { label: 'July', value: '07' },
  { label: 'August', value: '08' },
  { label: 'September', value: '09' },
  { label: 'October', value: '10' },
  { label: 'November', value: '11' },
  { label: 'December', value: '12' },
];

// Add "All" option at the top — for dropdown filters
export const monthOptions = [{ label: 'All', value: '' }, ...monthsList];


/**
 * yearsList → Contains only actual years (from 2025 to currentYear + 2)
 * yearOptions → Same as yearsList but includes an "All" option at the top
 */

// Generate a list of years starting from 2025 up to (current year + 2)
export const yearsList = Array.from(
    { length: currentYear - 2025 + 3 },
    (_, i) => {
        const yr = String(2025 + i); // Start from 2025 and increment sequentially
        return { label: yr, value: yr };
    }
);

// Add "All" option at the top
export const yearOptions = [{ label: "All", value: "" }, ...yearsList];